import { useEffect, useState } from 'react';
import { shouldRedirectToBankAccountInformationPage } from '../utils';

//TODO: Statsig po_request_1st_payout_method_on_finance_workspace. Remove after experiment finish
export const useAvoidNotificationsBasedOnFirstPayoutMethodExperiment = (
    isEligibleForFirstPayoutMethodExperiment: boolean | undefined,
    isStatsigInitialized: boolean,
    workspaceType: string,
) => {
    const [shouldAvoidNotifications, setShouldAvoidNotifications] =
        useState(true);

    useEffect(() => {
        if (workspaceType !== 'finance') {
            setShouldAvoidNotifications(false);
            return;
        }

        if (!isStatsigInitialized) return;

        if (isEligibleForFirstPayoutMethodExperiment === false) {
            setShouldAvoidNotifications(false);
            return;
        }

        if (!shouldRedirectToBankAccountInformationPage()) {
            setShouldAvoidNotifications(false);
        }
    }, [
        isStatsigInitialized,
        isEligibleForFirstPayoutMethodExperiment,
        workspaceType,
    ]);

    return { shouldAvoidNotifications };
};
